import React from 'react';

const QlikUIContext = React.createContext({});

export { QlikUIContext };
